import { useEffect } from 'react'
import { classes, style } from 'typestyle'

import { get } from '../../../__aeki__/share/find'
import { useLocation, useNavigate } from 'react-router-dom'
import useFetch from '../../../__aeki__/hooks/use-fetch'

import { Box } from '../../../__aeki__/components/box/box.component'
import { Button } from '../../../__aeki__/components/button'
import { Line } from '../../../__aeki__/components/line'
import { Heading } from '../../../__aeki__/components/text/heading.component'
import { Text } from '../../../__aeki__/components/text/text.component'
import { A } from '../../../__aeki__/components/a'

import { f14mdi } from '../../../__aeki__/styles/styleset/font-size/f14mdi'
import { f16i } from '../../../__aeki__/styles/styleset/font-size/f16i'
import { f18i } from '../../../__aeki__/styles/styleset/font-size/f18i'
import { hidemdi } from '../../../__aeki__/styles/styleset/hide/hidemdi'
import { mb32 } from '../../../__aeki__/styles/styleset/margin/mb32'
import { mb4 } from '../../../__aeki__/styles/styleset/margin/mb4'
import { mb8 } from '../../../__aeki__/styles/styleset/margin/mb8'
import { mr4 } from '../../../__aeki__/styles/styleset/margin/mr4'
import { mt8 } from '../../../__aeki__/styles/styleset/margin/mt8'
import { p4 } from '../../../__aeki__/styles/styleset/padding/p4'
import { pl8i } from '../../../__aeki__/styles/styleset/padding/pl8i'
import { pr8 } from '../../../__aeki__/styles/styleset/padding/pr8'
import { pr8i } from '../../../__aeki__/styles/styleset/padding/pr8i'
import { SimplerPagination } from '../../../__aeki__/modules/navigation/pagination'
import { useCheckLogin } from '../../childcares/components/check-login'

export const Childcares = (props: any) => {
  const historyLocation = useLocation()
  const checkLoginWrapper = useCheckLogin()
  const url = `${process.env.REACT_APP_API_URL}${historyLocation.pathname}/childcares`
  const [post, $post] = useFetch(
    { data: [] },
    {
      isLoading: true,
      search: {
        page: 1,
      },
    },
  )

  useEffect(() => {
    if (post.mounted && historyLocation.pathname) {
      $post.get({ url, search: { page: 1 } })
    }
  }, [post.mounted])

  const renderSubtitleItems = (items: any) => {
    return (
      items.length > 0 && (
        <Box
          className={classes(
            style({
              flexWrap: 'wrap',
            }),
          )}
          flex
        >
          {items.map((item: any, key: any) => {
            const { label, value, url, target } = item
            return (
              <Box
                baseline="background"
                className={classes(p4, mr4, pl8i, pr8i, mb4)}
                key={key}
                alignCenterX
                alignCenterY
                border
                rounded
              >
                <Text className={mr4} baseline="surface" size="xs" listLink semiBold>
                  {label}
                </Text>
                <Text baseline="surface" size="xs" listLink>
                  <a href={url} target={target}>
                    {value}
                  </a>
                </Text>
              </Box>
            )
          })}
        </Box>
      )
    )
  }

  return (
    <>
      <Box row>
        {!post.meta.isLoading && post.payload.data?.length === 0 ? (
          <Box row>
            <Text size="md" className={mb8}>
              Please contact the center to find about childcare
            </Text>
            <Box>
              <Button
                size="md"
                label={'Contact the centre'}
                baseline="primary"
                onClick={checkLoginWrapper(async () => {
                  const { Modal } = await import('../../../__aeki__/components/modal')
                  await import('../../../modals/childcare-contact')

                  Modal.push({
                    type: 'ChildcareContact',
                    componentProps: {
                      ccp: post.payload,
                      values: {
                        ticketType: 'General Inquiry',
                      },
                    },
                  })
                })}
                icon={<span className={classes('material-icons-two-tone', f18i)}>mail</span>}
                semiBold
                square
              />
            </Box>
          </Box>
        ) : (
          <>
            {post.payload.data?.map?.((item: any, key: any) => {
              const childcareId = get('body.originalGroup', item, 'string')
              const childcareName = get('body.generalInformation.name', item, 'string')
              const childcareAddress = get('body.generalInformation.addressLine1', item, 'string')
              const childcarePhone = get('body.generalInformation.phoneNumber', item, 'string')

              const items = renderSubtitleItems([
                {
                  label: 'Phone',
                  value: `${childcarePhone} (Call)`,
                  url: `tel:${childcarePhone}`,
                },
                {
                  label: 'Address',
                  value: `${childcareAddress} (See Map)`,
                  url: `/a/childcares?page=1&searchText=${childcareAddress}&openMap=true`,
                  target: '__blank',
                },
              ])

              return (
                <Box
                  className={classes(key !== post.payload.data.length - 1 && mb32)}
                  key={key}
                  row
                >
                  <Box flex spaceBetween alignBottom>
                    <A to={`/a/c/${childcareId}`} target="__blank">
                      <Box className={pr8} row>
                        <Heading baseline="surface" listLink>
                          {childcareName}{' '}
                          <i className={classes('material-icons-two-tone', f16i, f14mdi)}>
                            open_in_new
                          </i>
                        </Heading>
                      </Box>
                    </A>
                    <Button
                      className={hidemdi}
                      label="More Info"
                      baseline="primary"
                      size="sm"
                      onClick={async () => {
                        globalThis?.window?.open?.(`/a/c/${childcareId}`, '_blank')
                      }}
                      square
                    />
                  </Box>
                  <Line className={classes(mt8, mb8)} />
                  {items}
                </Box>
              )
            })}
            <SimplerPagination data={post} $data={$post} />
          </>
        )}
      </Box>
    </>
  )
}
